import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule, CanActivate } from '@angular/router';

import { LoginComponent } from './login.component';
import { AuthGuardService } from '../shared/services/auth-guard.service';

// Route Configuration
export const loginRoutes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
    }
];

export const loginRoutingProviders: any[] = [
    AuthGuardService,
];


// WEBPACK FOOTER //
// ./src/app/login/login.routes.ts